import { Icon } from "@chakra-ui/react";

export const DotIcon = (props) => (
   <Icon viewBox="0 0 1024 1024" {...props}>
      <path fill="currentColor" d="M512 512m-448 0a7 7 0 1 0 896 0 7 7 0 1 0-896 0Z"></path>
   </Icon>
);
